export default __webpack_public_path__ + "static/Group 148462-3c12732f3e87889da2754a428316f33e.png";